import React, {useEffect, useRef, useState} from "react";
import {useEEToolContext} from "../contexts/eeToolContext";
import {Box, Item} from "devextreme-react/box";
import {CustomerInformationControl} from "./CustomerInformationControl";
import Toolbar, {Item as ToolbarItem} from "devextreme-react/toolbar";
import {Button} from "devextreme-react/button";
import EstimateExitButton from "./EstimateExitButton";
import EstimateProductsControl from "./EstimateProductsControl";
import Popup, {ToolbarItem as PopupToolbarItem} from "devextreme-react/popup";
import {useNavigate} from "react-router";
import {showErrorMessage} from "../../../../utils/messages";
import LoadPanel from "devextreme-react/load-panel";
import {queryClient} from "../../../../lib/react-query";
import {useSaveEstimate} from "../api/save-estimate";
import PrintInternalCostTempButton from "../../../dealer/estimate/components/PrintInternalCostButtonTemp";
import {TextBox} from "devextreme-react/text-box";
import Validator, {RequiredRule} from "devextreme-react/validator";
import {useStoreInformation} from "../api/get-store-information";

export default function EEPricingControl() {
    const navigate = useNavigate();
    const context = useEEToolContext();
    const [isEstimatePopupVisible, setIsEstimatePopupVisible] = useState(false);
    const [isTicketNumberPopupVisible, setIsTicketNumberPopupVisible] = useState(false);
    const refTicketNumber = useRef<TextBox>(null);
    const storeInfo = useStoreInformation(context.dealerId);

    const getOKButtonOptions = {
        stylingMode: 'contained',
        text: 'Verify Ticket Number',
        validationGroup: 'ticketNumber',
        onClick: (e: any) => {
            let result = e.validationGroup.validate();
            if (result.isValid) {
                context.setTicketNumber(refTicketNumber.current?.instance.option('value') ?? '');
                let request = context.getSaveEstimateRequest();
                svEstimate.mutate();
                queryClient.invalidateQueries({queryKey: ['ee-tool-get-estimate', (request.quoteId ?? 0).toString()]});
                setIsTicketNumberPopupVisible(false);
            }
        },
    };

    const getCancelButtonOptions = {
        stylingMode: 'contained',
        text: 'Cancel',
        type: 'normal',
        onClick: () => {
            setIsTicketNumberPopupVisible(false);
        },
    };

    const [svEstimateInfo, setSvEstimateInfo] = useState<{
        isSuccess: boolean,
        estimateNumber: string
    }>();

    const svEstimate = useSaveEstimate(
        context.getSaveEstimateRequest(),
        (result) => {
            if (result.isSuccess) {
                setSvEstimateInfo({
                    isSuccess: result.isSuccess!,
                    estimateNumber: result.estimateNumber!
                });
            }
        },
        (error) => {
            showErrorMessage(error);
        });

    useEffect(() => {
        if (svEstimateInfo?.isSuccess) {
            setIsEstimatePopupVisible(true);
        }
    }, [svEstimateInfo?.isSuccess])

    const toggleEstimatePopup = () => {
        setIsEstimatePopupVisible(!isEstimatePopupVisible);
        navigate('/home')
    };

    const renderEstimateContent = () => {
        return (
            <div className={"ee-tool-estimate-submit-modal"} style={{textAlign: "center"}}>
                <p>Estimate {svEstimateInfo?.estimateNumber} has been submitted successfully</p>
                <div style={{marginTop: "10px"}}>
                    <Button onClick={() => toggleEstimatePopup()}>OK</Button>
                </div>
            </div>
        );
    }

    return <div>
        <Toolbar className='button-toolbar'>
            <ToolbarItem location={'before'}>
                <Button text='Submit Estimate' disabled={svEstimate.isLoading}
                        validationGroup='newEstimateValidationGroup' onClick={async (e) => {
                    let result = e.validationGroup.validate();
                    if (result.isValid) {
                        context.setTicketNumber('');
                        if (context.is25Check && storeInfo.data.businessFlowCode !== 'Lowe\'s') {
                            setIsTicketNumberPopupVisible(true);
                            return;
                        }
                        let request = context.getSaveEstimateRequest();
                        svEstimate.mutate();
                        queryClient.invalidateQueries({queryKey: ['ee-tool-get-estimate', (request.quoteId ?? 0).toString()]});
                    }
                }}
                />
            </ToolbarItem>
            <ToolbarItem location={'before'}>
                <EstimateExitButton/>
            </ToolbarItem>
            <ToolbarItem location={'after'}>
                <PrintInternalCostTempButton/>
            </ToolbarItem>
        </Toolbar>
        <LoadPanel visible={svEstimate.isLoading}></LoadPanel>
        <Box>
            <Item ratio={1}>
                <div style={{maxHeight: 300}}>
                    <CustomerInformationControl/>
                </div>
            </Item>
            <Item ratio={2}>
                <img src={context.imageData} style={{width: "100%", height: "100%", background: 'white'}}/>
            </Item>
            <Item ratio={1}>

            </Item>
        </Box>
        <EstimateProductsControl showCompareMaterialOptions={true}/>
        <Popup
            title={"Estimate"}
            visible={isEstimatePopupVisible}
            hideOnOutsideClick={true}
            width={400}
            height={200}
            onHiding={toggleEstimatePopup}
            showCloseButton={true}
            contentRender={renderEstimateContent}
        >
        </Popup>
        <Popup
            title={"Verify Ticket Number"}
            visible={isTicketNumberPopupVisible}
            hideOnOutsideClick={true}
            width={600}
            height={400}
            onHiding={() => {
                setIsTicketNumberPopupVisible(false);
            }}
            showCloseButton={true}
        >
            <PopupToolbarItem
                widget="dxButton"
                toolbar="bottom"
                location="after"
                options={getOKButtonOptions}
            />
            <PopupToolbarItem
                widget="dxButton"
                toolbar="bottom"
                location="after"
                options={getCancelButtonOptions}
            />
            <div>
                <p>
                    For All Jobs &lt; 25 sq. ft. you MUST contact your CFI for approval. Once approved by the CFI please
                    contact Customer Support for a ticket number & record the name of the CFI representative from whom
                    you received approval in the estimate notes section.
                </p>
                <div className="dx-field">
                    <TextBox
                        width={'100%'}
                        label='Enter Ticket Number'
                        labelMode={'outside'}
                        ref={refTicketNumber}
                    >
                        <Validator validationGroup='ticketNumber'>
                            <RequiredRule message={'Ticket Number is required'}></RequiredRule>
                        </Validator>
                    </TextBox>
                </div>
            </div>
        </Popup>
    </div>
        ;
}